<template>
  <v-container grid-list-xl>
    <v-layout wrap align-center>
      <v-dialog v-model="redoDialog" max-width="290">
        <v-card>
          <v-card-title color="primary" class="headline">Recover Asset</v-card-title>
          <v-card-text>Are you sure you want to recover {{selected.length}} items ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" flat="flat" @click="redoDialog = false">Cancel</v-btn>

            <v-btn color="primary" flat="flat" @click="redoDialog = false; recoverBulk()">Recover</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12>
     <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
     </v-flex>
      <v-form v-model="valid">
        <v-container>
          <v-layout row>
            <v-flex xs12 md12>
              <v-select v-model="assetTypeModel" :items="assetType" label="Type"></v-select>
            </v-flex>
          </v-layout>
        </v-container>
        <v-flex xs12>
          <v-btn color="primary" @click="search">Search</v-btn>
          <v-btn color="secondary" @click="clear">Clear</v-btn>
        </v-flex>
      </v-form>

      <v-flex xs12>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table
          dark
          :rows-per-page-items="[50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
          v-model="selected"
          select-all
          item-key="Discovery.AssetTag"
          :headers="headers"
          :items="assetsArr"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>
              <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
            </td>
            <td style="cursor : pointer " @click.stop="goTo(props.item)">
              <a style="color : secondary">{{ props.item.Discovery.AssetTag }}</a>
            </td>
            <td>{{ props.item.Time }}</td>
            <td>{{ props.item.AssetType }}</td>
          </template>
          <template v-slot:footer>
            <td :colspan="3">
              <strong>{{selected.length}} items selected</strong>
            </td>
            <td>
              <v-btn
                :disabled="selected.length == 0"
                @click.stop="redoDialog = true"
                color="info"
              >Recover</v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapFields } from "vuex-map-fields";
const fb = require("../firebaseConfig.js");
const { Parser } = require("json2csv");
export default {
  name: "assets",
  components: {},
      computed: {
    ...mapFields(["snackBarMessage",
        "snackBar","snackBarcolor"])
  },
  data() {
    return {
      items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Recycle Bin',
          disabled: false,
          to: 'recycle'
        }
      ],
      assetTypeModel : "",
      assetType : ["computer","monitor","phone"],
      selectedAsset: null,
      redoDialog: false,
      selected: [],
      title: "Search Recycled Asset",
      cpuSetting: [],
      assetsArr: [],
      valid: true,
      headers: [
        { text: "Asset", value: "Discovery.AssetTag", sortable: true },
        { text: "Created Time", value: "Time", sortable: true },
        { text: "Type", value: "AssetType", sortable: true },
      ]
    };
  },
  methods: {
    initData(){
       
      fb.AssetsCollections.where("Discovery.Status", "==", "Recycled")
          .orderBy("Time", "desc")
          .limit(50)
          .onSnapshot(querySnapshot => {
            this.assetsArr = [];
            querySnapshot.forEach(doc => {
              this.assetsArr.push(doc.data());
            });
            this.title =
              "Search Recycled Asset (Showing most recent 50 records order by time)";
          });
    },
    recoverBulk() {
      this.selected.forEach(input => {
        //remove asset from location if any
        fb.LocationsCollections.where(
          "assets",
          "array-contains",
          input.Discovery.AssetTag
        )
          .get()
          .then(items => {
            if (items.empty !== true) {
              items.forEach(item => {
                var docID = item.id;
                var collection = item.data().assets;
                collection = collection.filter(target => {
                  return target !== input.Discovery.AssetTag;
                });
                fb.LocationsCollections.doc(docID).update({
                  assets: collection
                });
              });
            }
          });
        //mark asset as ready
        fb.AssetsCollections.doc(input.Discovery.AssetTag).update({
          ["Discovery.Status"]: "ready"
        });
      });
    },

    goTo(item) {
      this.$router.push("/assets/" + item.Discovery.AssetTag);
    },
    csvOBJ() {
      var json = this.assetsArr.map(x => x.Discovery);
      const fields = [
        "id",
        "SystemInfo.Serial",
        "SystemInfo.Make",
        "SystemInfo.Model",
        "CpuTitle",
        "HddTitle",
        "RamTitle",
        "location"
      ];
      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(json);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += csv;
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
      return json;
    },
    clear() {
      this.assetTypeModel = "";
      this.initData()
    },
    search() {
      this.title = "Search Asset";
      if (this.assetTypeModel !== "") {
        this.assetsArr = []

        fb.AssetsCollections.where("AssetType", "==", this.assetTypeModel)
          .where("Discovery.Status", "==", "Recycled")
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach(doc => {
              this.assetsArr.push(doc.data());
            });
          });
      } else {
        this.snackBarcolor = "error";
        this.snackBarMessage = "at least 1 filter is required";
        this.snackbar = true;
      }
    }
  },
  mounted() {
    this.initData()
  }
};
</script>
